<template>
  <div class="all_part">
    <!--    <div class="head">-->
    <!--      <div class="Logo">-->
    <!--        <img src="../assets/Main_menu_img/main_menu_title_Logo.png" alt=""/>-->
    <!--      </div>-->
    <!--    </div>-->
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="button_input_all">
      <div class="back_button">
        <sapn class="back_buttons" @click="backMenu">返回</sapn>
      </div>
      <div class="tables_input_mainMenu_button">
        <div class="main_buttonAndInput">
          <div class="main_button">

            <div :class="this.pan_Show?'button_table_all':'button_table_all22'">
              <div>
                <div :class="pan_Show? 'CompetitiveChoice' : 'CompetitiveChoices'">
                  <div class="Main_menu_button_cl">
                    <div :class="pan_input==1?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                         @click="JingPinDengJi(item.id)"
                         v-for="item in tableTable" v-if="item.id==1">
                      <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                    <div :class="pan_input==3?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                         @click="JingPinDengJi(item.id)"
                         v-for="item in tableTable" v-if="item.id==3">
                      <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                    <div :class="pan_input==5?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                         @click="JingPinDengJi(item.id)"
                         v-for="item in tableTable" v-if="item.id==5">
                      <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="Main_menu_button_cl">
                    <div
                        :class="FABstaff_name_select==''&&staff_name_select==''||pan_input!=1?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss1'"
                        @click="JingPinDengJi2(item.id)"
                        v-for="item in tableTable" v-if="item.id==2">
                      <div class="CompetitiveChoice_button_alone">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                    <div
                        :class="OEMstaff_name_select==''&&FABstaff_name_select==''||pan_input!=3?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss2'"
                        @click="JingPinDengJi2(item.id)"
                        v-for="item in tableTable" v-if="item.id==4">
                      <div class="CompetitiveChoice_button_alone">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                    <div
                        :class="OEMstaff_name_select==''&&staff_name_select==''||pan_input!=5?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss3'"
                        @click="JingPinDengJi2(item.id)"
                        v-for="item in tableTable" v-if="item.id==6">
                      <div class="CompetitiveChoice_button_alone">
                        <span class="alone_span_title">{{ item.quadrant }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div :class="pan_Show?'input_buttonsss':'input_button'" v-show="pan_Show">
                  <div class="all_input">
                    <div class="all_input_top">
                      <div>
                        <div class="input_arr">
                          <div class="input_styles">
                            <div>
                              <el-input
                                  clearable
                                  v-model="key"
                                  placeholder="请输入搜索条件"
                                  style="width: 308px"
                              ></el-input>
                            </div>
                            <div class="submit_button">
                              <!-- <div class="search_button">
                      <el-button type="primary" @click="TianJiaZhanShi" style="height: 48px; width: 144px"
                      >报价筛选
                      </el-button
                      >
                    </div> -->
                              <div class="search_button">
                                <div class="sousuoButton">
                                  <el-button
                                      type="primary"
                                      @click="serchChanPin3"
                                      style="
                          height: 48px;
                          width: 144px;
                          margin-left: 20px;
                          font-size: 16px;
                        "
                                  >搜索
                                  </el-button>
                                  <div class="icon_sou">
                                    <img src="../assets/SouSuo.png" alt="" width="14px"/>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="input_style">
                          <el-input
                            v-model="oldMaterialNo"
                            placeholder="请输入旧料号"
                            style="width: 50px"
                          ></el-input>
                        </div> -->
                      <!-- <div>
                          <el-input
                            v-model="standard_code"
                            placeholder="请输入标准代码"
                            style="width: 50px"
                          ></el-input>
                        </div> -->
                      <!-- <div>
                        <el-input
                          v-model="inquiry_no"
                          placeholder="请输入询价单号"
                          style="width: 50px"
                        ></el-input>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="all_tables" v-if="pan_ShowTable==1">
                <div class="table" v-if="pan_input==1 || pan_input2==1">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index===0">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index===0">共查找数据 {{ totle }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index===0">当前第 {{ page || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData.data"
                      style="width: 100%; margin-top:12px"
                      height="324"
                      border
                      row-key="id"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="120" label="操作" fixed>
                      <template slot-scope="scope">
                        <a
                            @click="TianJiaTest(scope.row.id)"
                        >
                          详情
                        </a>
                        <!--                        <el-button-->
                        <!--                            @click="TianJiaTest(scope.row.id)"-->
                        <!--                        >-->
                        <!--                          详情-->
                        <!--                        </el-button>-->
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="160"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise"
                        label="竞争对手"
                        width="160"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_name"
                        label="竞争人员"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_type"
                        label="竞争对手关联类型"
                        width="140">
                    </el-table-column>
                    <el-table-column
                        prop="enterprise_end"
                        label="最终用户"
                        width="140">
                    </el-table-column>
                    <el-table-column
                        prop="enterprise_end_name"
                        label="最终用户关联人员"
                        width="140">
                    </el-table-column>
                    <el-table-column
                        prop="enterprise_end_type"
                        label="最终用户关联类型"
                        width="140">
                    </el-table-column>
                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系与活动"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="140"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="tablesss" v-if="pan_input2==1">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index==1">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index==1">共查找数据 {{ totle2 }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index==1">当前第 {{ pages || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData2.data"
                      style="width: 100%; margin-bottom: 20px;"
                      height="250"
                      border
                      row-key="id"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="115" label="操作" fixed>
                      <template slot-scope="scope">
                        <a
                            @click="TianJiaTest(scope.row.id)"
                        >
                          详情
                        </a>
                      </template>
                    </el-table-column>


                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="160"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise"
                        label="竞争对手"
                        width="160"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_name"
                        label="竞争人员"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_type"
                        label="竞争对手关联类型"
                        width="140">
                    </el-table-column>
                    -->

                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系&活动"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="140"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash2"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="table" v-if="pan_input==3 || pan_input2==3">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index==2">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index==2">共查找数据 {{ totle }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index==2">当前第 {{ page || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData.data"
                      style="width: 100%; margin-top:12px"
                      height="336"
                      border
                      row-key="id"
                      ref="multipleTable"

                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="110" label="操作" fixed>
                      <template slot-scope="scope">

                        <a @click="TianJiaTest(scope.row.id)">详情</a>

                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="equipment_supplier"
                        label="OEM设备商"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="related_personnel_supplier_name"
                        label="OEM关联人员"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_end"
                        label="最终用户"
                        width="140"
                    ></el-table-column>
                    <el-table-column

                        prop="enterprise_end_name"
                        label="最终用户关联人员"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_end_type"
                        label="最终用户关联类型"
                        width="140"
                    ></el-table-column>

                    <el-table-column
                        prop="device_type"
                        label="设备型号"
                        width="140"
                    ></el-table-column>
                    <!--                    <el-table-column-->
                    <!--                        prop="process_technology"-->
                    <!--                        label="制程工艺"-->
                    <!--                        width="100"-->
                    <!--                    ></el-table-column>-->
                    <!--                    <el-table-column-->
                    <!--                        prop="category"-->
                    <!--                        label="竞品类别"-->
                    <!--                        width="100"-->
                    <!--                    ></el-table-column>-->
                    <!--                    <el-table-column-->
                    <!--                        prop="equipment_condition"-->
                    <!--                        label="竞品&设备情况"-->
                    <!--                        width="100"-->
                    <!--                    ></el-table-column>-->
                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系与活动"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="140"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="tablesss" v-if="pan_input2==3">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index==3">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index==3">共查找数据 {{ totle2 }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index==3">当前第 {{ pages || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData.data"
                      style="width: 100%; "
                      height="250"
                      border
                      row-key="id"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="115" label="操作" fixed>
                      <template slot-scope="scope">
                        <a
                            @click="TianJiaTest(scope.row.id)"
                        >
                          详情
                        </a>
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="80"
                    ></el-table-column>

                    <el-table-column
                        prop="enterprise_end"
                        label="最终用户"
                        width="100"
                    ></el-table-column>
                    <el-table-column

                        prop="enterprise_end_name"
                        label="最终用户竞争人员"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_end_type"
                        label="最终用户关联类型"
                        width="100"
                    ></el-table-column>

                    <el-table-column
                        prop="device_type"
                        label="设备型号"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="process_technology"
                        label="制程工艺"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="category"
                        label="竞品类别"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="equipment_condition"
                        label="竞品&设备情况"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系与活动"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="100"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash2"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="table" v-if="pan_input==5 || pan_input2==5">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index==5">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index==5">共查找数据 {{ totle }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index==5">当前第 {{ page || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData.data"
                      style="width: 100%; margin-top:12px"
                      height="324"
                      border
                      row-key="id"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="115" label="操作" fixed>
                      <template slot-scope="scope">
                        <a @click="TianJiaTest(scope.row.id)">详情</a>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="product_number" label="平台产品编号" width="160"> -->
                    <!-- </el-table-column> -->

                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="120"
                    ></el-table-column>
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise"-->
                    <!--                  label="竞争对手"-->
                    <!--                  width="160"-->
                    <!--              ></el-table-column>-->
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise_name"-->
                    <!--                  label="竞争人员"-->
                    <!--                  width="140"-->
                    <!--              ></el-table-column>-->
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise_type"-->
                    <!--                  label="竞争对手关联类型"-->
                    <!--                  width="120">-->
                    <!--              </el-table-column>-->
                    <!--           -->
                    <!--            <el-table-column-->
                    <!--                prop="enterprise_end"-->
                    <!--                label="最终用户"-->
                    <!--                width="120"-->
                    <!--            ></el-table-column>-->
                    <!--            <el-table-column-->

                    <!--                prop="enterprise_end_name"-->
                    <!--                label="最终用户竞争人员"-->
                    <!--                width="180"-->
                    <!--            ></el-table-column>-->
                    <!--            <el-table-column-->
                    <!--                prop="enterprise_end_type"-->
                    <!--                label="最终用户关联类型"-->
                    <!--                width="120"-->
                    <!--            ></el-table-column>-->
                    <el-table-column
                        prop="equipment_supplier"
                        label="OEM设备商"
                        width="130"
                    ></el-table-column>
                    <el-table-column
                        prop="related_personnel_supplier_name"
                        label="OEM关联人员"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise"
                        label="竞争对手"
                        width="150"
                    ></el-table-column>
                    <el-table-column
                        prop="enterprise_name"
                        label="竞争对手关联人员"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="equipment_supplier_type"
                        label="设备关联类型"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="device_type"
                        label="设备型号"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="process_technology"
                        label="制程工艺"
                        width="100"
                    ></el-table-column>
                    <!--            <el-table-column-->
                    <!--                prop="category"-->
                    <!--                label="竞品类别"-->
                    <!--                width="140"-->
                    <!--            ></el-table-column>-->
                    <el-table-column
                        prop="equipment_condition"
                        label="竞品&设备情况"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系与活动"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="100"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash"
                    >
                    </el-pagination>
                  </div>
                </div>
                <div class="tablesss" v-if="pan_input2==5">
                  <div class="table_title">
                    <span v-for="(item,index) in tableTable" v-if="index==5">{{ item.quadrant }}</span>
                    <span v-for="(item,index) in tableTable" v-if="index==5">共查找数据 {{ totle2 }} 条</span>
                    <span v-for="(item,index) in tableTable" v-if="index==5">当前第 {{ pages || 1 }} 页</span>
                  </div>
                  <el-table
                      :data="tableData2.data"
                      style="width: 100%; "
                      height="250"
                      border
                      row-key="id"
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
                  >
                    <el-table-column type="index" width="115" label="操作" fixed>
                      <template slot-scope="scope">
                        <a
                            @click="TianJiaTest(scope.row.id)"
                        >
                          详情
                        </a>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="product_number" label="平台产品编号" width="160"> -->
                    <!-- </el-table-column> -->

                    <el-table-column
                        prop="quadrant"
                        label="所属象限"
                        width="100"
                    ></el-table-column>
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise"-->
                    <!--                  label="竞争对手"-->
                    <!--                  width="160"-->
                    <!--              ></el-table-column>-->
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise_name"-->
                    <!--                  label="竞争人员"-->
                    <!--                  width="120"-->
                    <!--              ></el-table-column>-->
                    <!--              <el-table-column-->
                    <!--                  prop="enterprise_type"-->
                    <!--                  label="竞争对手关联类型"-->
                    <!--                  width="120">-->
                    <!--              </el-table-column>-->
                    <!--           -->
                    <!--            <el-table-column-->
                    <!--                prop="enterprise_end"-->
                    <!--                label="最终用户"-->
                    <!--                width="120"-->
                    <!--            ></el-table-column>-->
                    <!--            <el-table-column-->

                    <!--                prop="enterprise_end_name"-->
                    <!--                label="最终用户竞争人员"-->
                    <!--                width="180"-->
                    <!--            ></el-table-column>-->
                    <!--            <el-table-column-->
                    <!--                prop="enterprise_end_type"-->
                    <!--                label="最终用户关联类型"-->
                    <!--                width="120"-->
                    <!--            ></el-table-column>-->
                    <el-table-column
                        prop="equipment_supplier"
                        label="OEM设备商"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="related_personnel_supplier_name"
                        label="设备竞争人员"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="equipment_supplier_type"
                        label="设备关联类型"
                        width="120"
                    ></el-table-column>
                    <el-table-column
                        prop="device_type"
                        label="设备型号"
                        width="100"
                    ></el-table-column>
                    <!--                    <el-table-column-->
                    <!--                        prop="process_technology"-->
                    <!--                        label="制程工艺"-->
                    <!--                        width="100"-->
                    <!--                    ></el-table-column>-->
                    <!--            <el-table-column-->
                    <!--                prop="category"-->
                    <!--                label="竞品类别"-->
                    <!--                width="140"-->
                    <!--            ></el-table-column>-->
                    <el-table-column
                        prop="equipment_condition"
                        label="竞品&设备情况"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="personnel_relations"
                        label="人员关系与活动"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="add_time"
                        label="添加时间"
                        width="100"
                    ></el-table-column>
                    <el-table-column
                        prop="edit_time"
                        label="修改时间"
                        width="100"
                    ></el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                        layout="prev, pager, next"
                        total="totle"
                        :current-page="page"
                        @current-change="reflash2"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
              <div class="all_input_tan_input" v-if="pan_ShowTable==2">
                <div class="all_input_control">
                  <div class="all_control" v-if="pan_input==1">
                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>FAB用户</span>
                      </div>
                      <!--                      <div class="type_selection">-->
                      <!--                        <div>-->
                      <!--                          <span>关联类型</span>-->
                      <!--                        </div>-->
                      <!--                        <el-radio-group v-model="selectFAB">-->
                      <!--                          <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
                      <!--                                    :disabled="opt.id!=jinxuan3">-->
                      <!--                            {{ opt.value }}-->
                      <!--                          </el-radio>-->
                      <!--                        </el-radio-group>-->
                      <!--                      </div>-->
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联企业</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('b', FABcompanChoice)">
                              <el-option
                                  v-for="item in FABcompanyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>

                          </div>
                          <div>
                            <el-button @click="add_companyTable=2">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="FABstaff_name_select" filterable placeholder="请选择"
                                       style="width: 200px">
                              <el-option
                                  v-for="item in FABcompanyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_FABstaff">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>制程工艺</span>
                          </div>
                          <div class="all_input">

                            <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                              <el-option
                                  v-for="item in processTable"
                                  :key="item.value"
                                  :label="item.process_technology"
                                  :value="item.process_technology">
                              </el-option>
                            </el-select>
                          </div>
                          <!--                          <div>-->
                          <!--                            <el-button @click="Pan_add_process">新增</el-button>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="all_control" v-if="pan_input==1">
                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>竞争者信息</span>
                      </div>
                      <!--                      <div class="type_selection">-->
                      <!--                        <div>-->
                      <!--                          <span>关联类型</span>-->
                      <!--                        </div>-->
                      <!--                        <div>-->
                      <!--                          <el-radio-group v-model="selectC">-->
                      <!--                            <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
                      <!--                                      :disabled="opt.id!=pan_input">-->
                      <!--                              {{ opt.value }}-->
                      <!--                            </el-radio>-->
                      <!--                          </el-radio-group>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联企业</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('a', companyChoice)">
                              <el-option
                                  v-for="item in companyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_companyTable">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                            >
                              <el-option
                                  v-for="item in companyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_staff()">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button" v-show="pan_input!=5">
                          <div class="titles">
                            <span>竞品类别</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 200px">
                              <el-option
                                  v-for="item in categoryTable"
                                  :key="item.value"
                                  :label="item.title"
                                  :value="item.title">
                              </el-option>
                            </el-select>
                          </div>
                          <!--                          <div>-->
                          <!--                            <el-button @click="Pan_add_category">新增</el-button>-->

                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="all_control" v-if=" pan_input==3">
                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>FAB用户</span>
                      </div>
                      <!--                      <div class="type_selection">-->
                      <!--                        <div>-->
                      <!--                          <span>关联类型</span>-->
                      <!--                        </div>-->
                      <!--                        <el-radio-group v-model="selectFAB">-->
                      <!--                          <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
                      <!--                                    :disabled="opt.id!=pan_input">-->
                      <!--                            {{ opt.value }}-->
                      <!--                          </el-radio>-->
                      <!--                        </el-radio-group>-->
                      <!--                      </div>-->
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联企业</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('b', FABcompanChoice)">
                              <el-option
                                  v-for="item in FABcompanyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>

                          </div>
                          <div>
                            <el-button @click="add_companyTable=2">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="FABstaff_name_select" filterable placeholder="请选择"
                                       style="width: 200px">
                              <el-option
                                  v-for="item in FABcompanyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_FABstaff">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>制程工艺</span>
                          </div>
                          <div class="all_input">

                            <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                              <el-option
                                  v-for="item in processTable"
                                  :key="item.value"
                                  :label="item.process_technology"
                                  :value="item.process_technology">
                              </el-option>
                            </el-select>
                          </div>
                          <!--                          <div>-->
                          <!--                            <el-button @click="Pan_add_process">新增</el-button>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>配套密封圈厂家</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('b', FABcompanChoice)">
                              <el-option
                                  v-for="item in FABcompanyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>

                          </div>
                          <div>
                            <el-button @click="add_companyTable=2">新增</el-button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="all_control" v-if="  pan_input==3">
                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>OEM设备商</span>
                      </div>
                      <!--                      <div class="type_selection">-->
                      <!--                        <div>-->
                      <!--                          <span>关联类型</span>-->
                      <!--                        </div>-->
                      <!--                        <el-radio-group v-model="selectOEM">-->
                      <!--                          <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
                      <!--                                    :disabled="opt.id!=jinxuan4">-->
                      <!--                            {{ opt.value }}-->
                      <!--                          </el-radio>-->
                      <!--                        </el-radio-group>-->
                      <!--                      </div>-->
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联企业</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('c', OEMcompanyChoice)">
                              <el-option
                                  v-for="item in OEMcompanyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>

                          </div>
                          <div>
                            <el-button @click="add_companyTable=3">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择"
                                       style="width: 200px">
                              <el-option
                                  v-for="item in OEMcompanyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_OEMstaff">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button" v-show="pan_input!=1">
                          <div class="titles">
                            <span>设备型号</span>
                          </div>
                          <div class="all_input">

                            <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 200px"
                                       clearable
                                       @change="change('d', companyChoice)">
                              <el-option
                                  v-for="item in deviceTable"
                                  :key="item.value"
                                  :label="item.device_type"
                                  :value="item.device_type">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_device_type">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>机台数量</span>
                          </div>
                          <div class="all_input">
                            <el-input
                                style="width: 200px"
                                type="text"
                                placeholder="请输入内容"
                                v-model="equipment_condition">
                            </el-input>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="all_control" v-if="  pan_input==5">

                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>OEM设备商</span>
                      </div>
                      <!--                      <div class="type_selection">-->
                      <!--                        <div>-->
                      <!--                          <span>关联类型</span>-->
                      <!--                        </div>-->
                      <!--                        <el-radio-group v-model="selectOEMs">-->
                      <!--                          <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
                      <!--                                    :disabled="opt.id!=pan_input">-->
                      <!--                            {{ opt.value }}-->
                      <!--                          </el-radio>-->
                      <!--                        </el-radio-group>-->
                      <!--                      </div>-->
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联企业</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px"
                                       value-key="id"
                                       clearable @change="change('c', OEMcompanyChoice)">
                              <el-option
                                  v-for="item in OEMcompanyTable"
                                  :key="item.id"
                                  :label="item.enterprise"
                                  :value="{id:item.id, companyName:item.enterprise}"
                              >
                              </el-option>
                            </el-select>

                          </div>
                          <div>
                            <el-button @click="add_companyTable=3">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择"
                                       style="width: 200px">
                              <el-option
                                  v-for="item in OEMcompanyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_OEMstaff">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button" v-show="pan_input!=1">
                          <div class="titles">
                            <span>设备型号</span>
                          </div>
                          <div class="all_input">

                            <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 200px"
                                       clearable
                                       @change="change('d', companyChoice)">
                              <el-option
                                  v-for="item in deviceTable"
                                  :key="item.value"
                                  :label="item.device_type"
                                  :value="item.device_type">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_device_type">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>制程工艺</span>
                          </div>
                          <div class="all_input">

                            <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                              <el-option
                                  v-for="item in processTable"
                                  :key="item.value"
                                  :label="item.process_technology"
                                  :value="item.process_technology">
                              </el-option>
                            </el-select>
                          </div>
                          <!--                          <div>-->
                          <!--                            <el-button @click="Pan_add_process">新增</el-button>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="all_control" v-if="pan_input==5">
                    <div class="all_control_input_button">
                      <div class="Type_title">
                        <span>竞争者信息</span>
                      </div>
                      <div class="title_input_button">
                        <div class="titles">
                          <span>关联企业</span>
                        </div>
                        <div class="all_input">
                          <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px"
                                     value-key="id"
                                     clearable @change="change('a', companyChoice)">
                            <el-option
                                v-for="item in companyTable"
                                :key="item.id"
                                :label="item.enterprise"
                                :value="{id:item.id, companyName:item.enterprise}"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div>
                          <el-button @click="Pan_add_companyTable">新增</el-button>
                        </div>
                      </div>


                      <div>
                        <div class="title_input_button">
                          <div class="titles">
                            <span>关联人员</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                            >
                              <el-option
                                  v-for="item in companyStaffTable"
                                  :key="item.value"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </div>
                          <div>
                            <el-button @click="Pan_add_staff()">新增</el-button>
                          </div>
                        </div>

                      </div>
                      <div>
                        <div class="title_input_button" v-show="pan_input==5">
                          <div class="titles">
                            <span>竞品类别</span>
                          </div>
                          <div class="all_input">
                            <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 200px">
                              <el-option
                                  v-for="item in categoryTable"
                                  :key="item.value"
                                  :label="item.title"
                                  :value="item.title">
                              </el-option>
                            </el-select>
                          </div>
                          <!--                          <div>-->
                          <!--                            <el-button @click="Pan_add_category">新增</el-button>-->

                          <!--                          </div>-->
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="all_input_controls" v-if="pan_input2==''">
                  <div class="all_controls">
                    <div class="all_control_input_buttons">
                      <div class="all_control_input_buttons_textar">
                        <div
                            :class="OEMstaff_name_select===''&&staff_name_select===''&&FABstaff_name_select===''?'left':'lefts'">
                          <div class="title_input_buttons">
                            <div class="table_title" style="margin-bottom: 30px">
                              <span v-if="this.pan_input==1||this.pan_input==5">竞品状况</span>
                              <span v-if="this.pan_input==3">设备信息</span>
                            </div>
                            <div class="all_input">
                              <el-input
                                  style="width: 390px"
                                  type="textarea"
                                  :rows="5"
                                  placeholder="请输入内容"
                                  v-model="equipment_condition">
                              </el-input>
                            </div>

                          </div>
                          <div class="title_input_buttons"
                               v-show="OEMstaff_name_select!=''||this.staff_name_select!=''||FABstaff_name_select!=''"
                               style="margin-right: 74px">
                            <div class="table_title" style="margin-bottom: 30px">
                              <span>人员关系活动</span>
                            </div>
                            <div class="all_input">
                              <el-input
                                  style="width: 390px"
                                  type="textarea"
                                  :rows="5"
                                  placeholder="请输入内容"
                                  v-model="personnel_relations">
                              </el-input>
                            </div>
                          </div>


                        </div>

                      </div>


                      <div class="button_update">
                        <el-button type="primary" style="height: 56px; width: 190px;margin-right: 20px;font-size: 16px"
                                   @click="updateAll"
                        >点击提交
                        </el-button
                        >
                        <div class="Login_button">
                          <el-upload
                              class="upload-demo"
                              action="http://hairong.zhongqinchina.com/api/up_files/upload"
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              :before-remove="beforeRemove"
                              :before-upload="beforeAvatarUpload"
                              :on-success="urlChange"
                              multiple
                              :limit="1"
                              :on-exceed="handleExceed"
                              :file-list="fileList">
                            <div class="updateIcon">

                              <img src="../assets/Updata.png" width="20px"/>
                              <span>附件</span>
                            </div>
                          </el-upload>
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                <div class="add_info" v-if="add_staff_type===1">
                  <div class="back_icon" @click="Pan_add_staff">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>企业</span>
                    <el-input style="width: 200px" :value="companyChoice.companyName" :disabled="false"
                              :v-model="staff_companyChoice=companyChoice.id"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>姓名</span>
                    <el-input style="width: 200px" v-model="staff_Name"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>职务</span>
                    <el-input style="width: 200px" v-model="staff_post"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>手机号</span>
                    <el-input style="width: 200px" v-model="staff_phone"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>邮箱</span>
                    <el-input style="width: 200px" v-model="staff_wechart"></el-input>
                  </div>

                  <div class="add_info_button">
                    <el-button @click="addStaff">添加</el-button>
                    <!--                    <el-button @click="Pan_add_staff">返回</el-button>-->
                  </div>
                </div>
                <div class="add_info" v-if="add_companyTable===1">
                  <div class="back_icon" @click="Pan_add_companyTable">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>企业名称</span>
                    <el-input style="width: 200px" v-model="add_company_name"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>简称</span>
                    <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addcompany">添加</el-button>
                    <el-button @click="Pan_add_companyTable">返回</el-button>
                  </div>
                </div>
                <div class="add_info" v-if="add_staff_type===2">
                  <div class="back_icon" @click="Pan_add_staff">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>企业</span>
                    <el-input style="width: 200px" :value="FABcompanChoice.companyName" :disabled="false"
                              :v-model="staff_companyChoice=FABcompanChoice.id"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>姓名</span>
                    <el-input style="width: 200px" v-model="staff_Name"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>手机号</span>
                    <el-input style="width: 200px" v-model="staff_phone"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>邮箱</span>
                    <el-input style="width: 200px" v-model="staff_wechart"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>职务</span>
                    <el-input style="width: 200px" v-model="staff_post"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addFABStaff">添加</el-button>
                    <!--                    <el-button @click="Pan_add_staff">返回</el-button>-->
                  </div>
                </div>
                <div class="add_info" v-if="add_companyTable===2">
                  <div class="back_icon" @click="Pan_add_companyTable">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>企业名称</span>
                    <el-input style="width: 200px" v-model="add_company_name"></el-input>
                  </div>

                  <div class="add_staff_info_titleAndInput">
                    <span>类型</span>
                    <el-input style="width: 200px" v-model="type_fab"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>地区</span>
                    <el-input style="width: 200px" v-model="region_fab"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addFABcompany">添加</el-button>
                    <!--                    <el-button @click="Pan_add_companyTable">返回</el-button>-->
                  </div>
                </div>
                <div class="add_info" v-if="add_staff_type===3">
                  <div class="back_icon" @click="Pan_add_staff">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">

                    <span>企业</span>
                    <el-input style="width: 200px" :value="OEMcompanyChoice.companyName" :disabled="false"
                              :v-model="staff_companyChoice=OEMcompanyChoice.id"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>姓名</span>
                    <el-input style="width: 200px" v-model="staff_Name"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>手机号</span>
                    <el-input style="width: 200px" v-model="staff_phone"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>邮箱</span>
                    <el-input style="width: 200px" v-model="staff_wechart"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>职务</span>
                    <el-input style="width: 200px" v-model="staff_post"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addOEMStaff">添加</el-button>
                    <!--                    <el-button @click="Pan_add_staff">返回</el-button>-->
                  </div>
                </div>
                <div class="add_info" v-if="add_companyTable===3">
                  <div class="back_icon" @click="Pan_add_companyTable">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>企业名称</span>
                    <el-input style="width: 200px" v-model="add_company_name"></el-input>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>简称</span>
                    <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addOEMcompany">添加</el-button>
                    <!--                    <el-button @click="Pan_add_companyTable">返回</el-button>-->
                  </div>
                </div>
                <div class="add_info" v-if="add_device_type===1">
                  <div class="back_icon" @click="Pan_add_device_type">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>设备商</span>
                    <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px"
                               value-key="id"
                               clearable @change="change('c', OEMcompanyChoice)"
                               disabled="false">
                      <el-option
                          v-for="item in OEMcompanyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>设备型号</span>
                    <el-input style="width: 200px" v-model="add_device"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addDevice">添加</el-button>
                  </div>
                </div>
                <div class="add_info" v-if="add_process===1">
                  <div class="back_icon" @click="Pan_add_process">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>制程工艺</span>
                    <el-input style="width: 200px" v-model="add_process_input"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addProcess">添加</el-button>

                  </div>
                </div>
                <div class="add_info" v-if="add_category===1">
                  <div class="back_icon" @click="Pan_add_companyTable">
                    <img src="../assets/close.png" alt="" width="30px">
                  </div>
                  <div class="add_staff_info_titleAndInput">
                    <span>竞品类别</span>
                    <el-input style="width: 200px" v-model="add_category_input"></el-input>
                  </div>
                  <div class="add_info_button">
                    <el-button @click="addCategory">添加</el-button>

                  </div>
                </div>
                <div class="test"
                     v-show="add_staff_type!=0||add_companyTable!=0||add_companyTable!=0||add_device_type!=0||add_process!=0||add_category!=0"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "@/components/publics";
import titleBlock_computer from "../views/titleBlock_computer.vue";

export default {
  name: "Main_menuComputer",
  data() {
    return {
      type_fab: "",
      region_fab: "",
      page: 1,
      pages:1,
      pan_ShowTable: "",
      pan_Show: false,
      pan_input: "",
      pan_input2: "",
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: "",
      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_companyTable: 0,
      add_staff_type: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: "",//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      OEMcompanyTable: {},//OEM公司列表
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      processTable: {},//制程工艺列表
      categoryTable: {},//制程工艺列表
      OEMcompanyChoice: {},//公司列表
      companyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      deviceChoice: "",//设备选择
      processChoice: "",//制程工艺列表
      categoryChoice: "",//制程工艺列表
      companyStaffChoice: "",
      staff_companyChoice: "",
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      quadrant_name: "",
      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",
      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表
      staff_post: "",
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM: "",
      selectOEMs: "",
      urlImage: '',
      fileList: [],
      tableTable: [],
      user_leave: {},
      tableData: [],
      tableData2: [],
      tableDataInfo: [],
      go_info_id: "",
      key: "",
      totle: "",
      totle2: "",
      equipment_condition: "",
      personnel_relations: "",
    };
  },
  components: {
    titleBlock_computer,
  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
      this.selectdevice(newName.id);
    },

  },
  mounted() {
    this.getUser();
    this.Name();
    this.selectName();
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();

    this.selectprocess();
    this.selectCategory();
    this.getUser();
  },
  methods: {
    clearInput() {
      this.staff_name_select = ""
      this.FABstaff_name_select = ""
      this.OEMstaff_name_select = ""
      this.OEMcompanyChoice = ""
      this.companyChoice = ""
      this.FABcompanChoice = ""
      this.deviceChoice = ""
      this.processChoice = ""
      this.categoryChoice = ""
      this.ompanyStaffChoice = ""
      this.staff_companyChoice = ""
      this.equipment_condition = ""
      this.personnel_relations = ""

    },
    clearInput2() {
      this.staff_Name = "";
      this.staff_phone = "";
      this.staff_wechart = "";

    },
    TianJiaTest(val) {
      // this.infoAll(val)
      this.Go_info(val);
    },
    Name() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/quadrant`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableTable = response.data.data;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    JingPinDengJi(val) {
      this.clearInput();
      this.page = 1;
      this.pan_input = ""
      this.pan_input2 = ""
      console.log()
      this.pan_Show = true;
      this.pan_input = val
      this.serchChanPin(val)

    },
    JingPinDengJi2(val) {
      if (this.FABstaff_name_select != '' || this.OEMstaff_name_select != '' || this.staff_name_select != '' || this.key != '') {
        this.pages = 1;
        this.pan_input = val
        this.pan_input2 = val - 1
        this.serchChanPin(this.pan_input2)
        this.serchChanPin2(val)
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {

    },
    urlChange(e) {
      console.log('url', e);
      if (e.code == 200) {
        this.urlImage = e.data.img
      }
    },
    beforeAvatarUpload(file) {
      console.log('file', file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      var arr = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'PNG', 'JPEG', 'JPG', 'PDF', 'DOC'];
      let status = arr.findIndex((value, key) => {
        return fileName == value
      });
      console.log('fileName', fileName, status);
      if (status == -1) {
        this.$message('上传文件只能是 png、jpeg、jpg、pdf、doc格式!');
        return false
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    //新增公司
    addcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增FAB公司
    addFABcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseEndAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                // abbreviation: this.add_company_abbreviation,
                type: this.type_fab,
                region: this.region_fab,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectFABcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增公司
    addOEMcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/equipmentSupplierAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectOEMcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelAdd",
              this.$qs.stringify({
                enterprise_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.selectcompanystaff(this.companyChoice.id);
              this.add_staff_type = 0;

            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增FAB销售人员
    addFABStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelEndAdd",
              this.$qs.stringify({
                enterprise_end_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompanystaff(this.FABcompanChoice.id)
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增设备型号
    addDevice() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/deviceTypeAdd",
              this.$qs.stringify({
                device_type: this.add_device,
                equipment_supplier_id: this.OEMcompanyChoice.id
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_device_type = 0;
              this.selectdevice()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增制程工艺
    addProcess() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/processTechnologyAdd",
              this.$qs.stringify({
                process_technology: this.add_process_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_process = 0;
              this.selectprocess()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增竞品类别
    addCategory() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/categoryAdd",
              this.$qs.stringify({
                title: this.add_category_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_category = 0;
              this.selectCategory()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增OEM销售人员
    addOEMStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelSupplierAdd",
              this.$qs.stringify({
                enterprise_supplier_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectOEMcompanystaff(this.OEMcompanyChoice.id)
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    changeSelect() {
      this.$forceUpdate()
    },
    //判断是否打开新增竞争公司销售人员弹窗
    Pan_add_staff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.companyChoice).length != "") {
          this.add_staff_type = 1
          this.clearInput2();
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否打开新增FAB销售人员弹窗
    Pan_add_FABstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.FABcompanChoice).length != "") {
          this.add_staff_type = 2
          this.clearInput2();
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    Pan_add_companyTable() {
      if (this.add_companyTable == 0) {
        this.add_companyTable = 1
      } else {
        this.add_companyTable = 0
      }
    },
    Pan_add_device_type() {
      if (this.add_device_type == 0) {
        this.add_device_type = 1
      } else {
        this.add_device_type = 0
      }
    },
    Pan_add_category() {
      if (this.add_category == 0) {
        this.add_category = 1
      } else {
        this.add_category = 0
      }
    },
    Pan_add_process() {
      if (this.add_process == 0) {
        this.add_process = 1
      } else {
        this.add_process = 0
      }
    },
    //判断是否打开新增OEM销售人员弹窗
    Pan_add_OEMstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.OEMcompanyChoice).length != "") {
          this.add_staff_type = 3
          this.clearInput2();
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type?equipment_supplier_id=${this.OEMcompanyChoice.id}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询竞争对手销售人员
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺
    updateAll() {
      if (this.pan_input == 1) {
        this.selectC = '竞争者';
        this.selectFAB = 'Fab用户';
        this.selectOEMs = '';
      } else if (this.pan_input == 3) {
        this.selectC = '';
        this.selectFAB = 'Fab用户'
        this.selectOEMs = 'OEM供应商'
      } else if (this.pan_input == 5) {
        this.selectC = '竞争者';
        this.selectOEMs = 'OEM供应商';
        this.selectFAB = '';
      }
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductAdd",
              this.$qs.stringify({
                user_id: this.user_leave.id,
                quadrant_id: this.pan_input,
                enterprise_id: this.companyChoice.id,
                enterprise_user_id: this.staff_name_select,
                enterprise_type: this.selectC,
                enterprise_end_id: this.FABcompanChoice.id,
                enterprise_end_user_id: this.FABstaff_name_select,
                enterprise_end_type: this.selectFAB,
                equipment_supplier_id: this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,
                equipment_supplier_type: this.selectOEMs,
                device_type: this.deviceChoice,
                process_technology: this.processChoice,
                category: this.categoryChoice,
                equipment_condition: this.equipment_condition,
                personnel_relations: this.personnel_relations,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.pan_ShowTable = 0;
              this.pan_Show = false;
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPin(valas) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.totle = "";
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${valas}&page=${this.page}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              if (this.key == '') {
                this.pan_ShowTable = 2
              } else {
                this.pan_ShowTable = 1
              }
              this.tableData = response.data.data;
              this.totle = response.data.data.total;
              console.log(this.totle)
              console.log(this.tableData)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            // this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPin2(valas) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.totle2 = '';
      if (this.key == '') {
        this.pan_ShowTable = 2
      } else {
        this.pan_ShowTable = 1
      }
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${valas}&page=${this.pages}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableData2 = response.data.data;
              this.totle2 = response.data.data.total
              console.log(this.tableData2)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData2 = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            // this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPin3() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.totle = '';
      if (this.key == '') {
        this.pan_ShowTable = 2
      } else {
        this.pan_ShowTable = 1
      }
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${this.pan_input}&page=${this.page}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableData = response.data.data;
              this.totle = response.data.data.total
              console.log(this.tableData2)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData2 = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            // this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    infoAll(infoID) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductDetails?id=${infoID}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableDataInfo = response.data.data;
              console.log(this.tableDataInfo)

              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableDataInfo = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    reflash(val) {
      this.page = val;
      console.log(this.page, '这里看的是page');
      console.log(this.pan_input, '这里看的是pan_input')
      this.serchChanPin(this.pan_input)
    },
    reflash2(val) {
      this.pages = val;
      console.log(this.pages, '这里看的是pages');
      console.log(this.pan_input2, '这里看的是pan_input2')
      this.serchChanPin2(this.pan_input)
    },
    Go_info(val) {
      this.$router.push(
          {
            name: "CompetitionRegistrationInfo",
            params: {
              data: val
            }
          }
      );
    },
    backMenu() {
      this.$router.push("/Main_menuComputer");
    }
  },
};
</script>

<style>

</style>
<style scoped>
.main_buttonAndInput {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.all_tables {
  width: 68%;
  height: 100%;
}


.alone_span_title {
  color: #ffffff;
  font-size: 24px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 38%;
  height: 88%;
  margin-left: 30px;
}

.CompetitiveChoices {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 40%;
  height: 88%;
}

.button_input_all {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  justify-content: center;

}

.CompetitiveChoice_button_alone {
  background: #8EC31F;
  height: 88%;
  width: 94%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss div {
  /*background: #FC6700*/
  background: #999999;
}

.CompetitiveChoice_buttonss1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss1 div {
  background: #99c0db;
}

.CompetitiveChoice_buttonss2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss2 div {
  background: #99c0db;
}

.CompetitiveChoice_buttonss3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss3 div {
  background: #99c0db;
}

.row_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.all_part {
  background-image: url("../assets/table_logo2.png");

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  min-height: 925px;
  min-width: 1920px;
}

.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;


}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.input_style {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
}

.input_styles {
  width: 55%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input_arr {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border: 1px #999999 dashed; */
}

.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}

.ShouQi {
  position: relative;
}


.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;

}

.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}

.Fanhu {
  position: relative;
}

.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;

  border-radius: 6px;
}

.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.Main_menu_button_cl {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  height: 400px;
}

.add_info {
  width: 25%;
  height: 42%;
  background: rgb(255, 255, 255);
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
}

.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 14%;
  text-align: left;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 36%;
}

.lefts {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.left {
  display: flex;
  flex-direction: row;
  width: 90%;
}

.all_control_input_buttons_textar {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 70%;
}

.all_input_control {
  height: 50%;
  display: flex;
  justify-content: space-around;
  margin-bottom: 58px;
}

.all_input_controls {
  height: 62%;
  display: flex;
  justify-content: space-around;
}

.all_control_input_button {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sousuoButton {
  position: relative;
}

.all_control_input_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Type_title {
  text-align: left;
  font-weight: 600;
}

.Type_title span {

  font-weight: 600;
}

.type_selection {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.all_control {
  width: 36%;
  display: flex;
  justify-content: center;

}

.title_input_buttons .titles {
  align-items: center;
  display: flex;
  flex-direction: row;
  /*width: 50%;*/
  justify-content: space-between;
}

.title_input_buttons {
  margin-right: 114px;
}


.all_controls {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90%;
}

.title_input_button {
  align-items: center;
  display: flex;
  flex-direction: row;
  /*width: 50%;*/

}

.input_button {
  display: flex;
  flex-direction: row;

  /*justify-content: center;*/
  justify-content: space-between;
}

.input_buttonsss {
  display: flex;
  flex-direction: row;

  justify-content: center;
  /*justify-content: space-between;*/
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input {
  display: flex;
  flex-direction: column;
}

.alone_span_title {
  color: #ffffff;
  font-size: 20px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}


.CompetitiveChoice_button {

  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;
}

.CompetitiveChoice_button_ch {
  background: #bedfff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190pt;
  height: 82pt;
  border-radius: 4px;

}

.row_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}


.head {
  background-image: url("../assets/Main_menu_img/menu_title_bg.png");
  display: flex;
  justify-content: center;
}

.main_button {
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  height: 100%;
}

.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 80%;
}

.Logo {
  margin-top: 30px;
}

.button_update {

  height: 150px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 200px;
  width: 200px;
  background-color: #18a575;
  border-radius: 6px;
}

.button span {
  font-weight: 600;
  color: #ffffff;
  font-size: 20px;
  margin-top: 30px;
}

.Copyright_information {
  margin-bottom: 15px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.tavless {
  height: 50%;
}

.tables_input_mainMenu_button {
  display: flex;
  flex-direction: row;
}

.button_table_all {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}


.block {

  width: 100%;

}

.table {
  height: 55%;

}

.tablesss {
  height: 50%;

}

.all_input_tan_input {
  width: 100%;
}

.button_table_all {
  width: 100%;
}

.button_table_all22 {
  display: flex;
  width: 30%;
  flex-direction: column;
  justify-content: center;
}

.test {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.updateIcon {
  width: 80px;
  background: #008de3;
  border-radius: 4px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
}

.table_title {

  width: 35%;
  display: flex;
  flex-direction: row;
  text-align: left;
  font-weight: 600;
  align-items: center;
  justify-content: space-around;
}

.back_button {
  width: 100%;
  height: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.back_buttons {
  margin-right: 30px;
  border-radius: 25px;
  height: 100%;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: #008de3 solid 1px;
  color: #008de3;
}

.back_icon {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 95%;
}
</style>
